import { useQueryClient } from '@tanstack/react-query';
import { updateConfidenceScores } from '../../../../api/submissions/submissions.api';
import { queries } from '../../../../queries';

export const useUpdateConfidenceScores = () => {
  const queryClient = useQueryClient();

  const updateScores = (
    submissionId: string,
    confidenceScores: Record<string, number>
  ) => {
    return updateConfidenceScores(submissionId, {
      data: confidenceScores,
    })
      .then(() => {
        return queryClient.invalidateQueries(
          queries.submissions.detailsWithConfidence(submissionId).queryKey
        );
      })
      .then(() => {
        return queryClient.refetchQueries(
          queries.submissions.detailsWithConfidence(submissionId).queryKey
        );
      })
      .then(() => {
        // Invalidate dynamic form queries so Security Assessment confidence scores
        // (sourced from the form schema, not detailsWithConfidence) are refreshed.
        return queryClient.invalidateQueries({
          queryKey: ['dynamic-form', { submissionId }],
        });
      });
  };

  return { updateScores };
};
